export default "__VITE_ASSET__CXqvDzVy__"